<template>
  <AccountOpePanel>
    <div class="aiz-titlebar mt-2 mb-4">
      <div class="row align-items-center">
        <div class="col-md-6">
          <h1 class="h3">{{ $t("订单编号") }}: {{ order.no }}</h1>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-header">
        <h5 class="h6 mb-0">{{ $t("订单摘要") }}</h5>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-lg-6">
            <table class="table-borderless table">
              <tbody>
                <tr>
                  <td class="w-50 fw-600">{{ $t("订单编号") }}:</td>
                  <td>{{ order.no }}</td>
                </tr>
                <tr>
                  <td class="w-50 fw-600">{{ $t("收货人") }}:</td>
                  <td>{{ order.receiver }}</td>
                </tr>
                <tr>
                  <td class="w-50 fw-600">{{ $t("Email") }}:</td>
                  <td>{{ userInfo.email }}</td>
                </tr>
                <tr>
                  <td class="w-50 fw-600">{{ $t("收件地址") }}:</td>
                  <td>
                    {{ order.addressDetail }}, {{ order.postalCode }},
                    {{ order.city }}, {{ order.province }},
                    {{ order.district }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-lg-6">
            <table class="table-borderless table">
              <tbody>
                <tr>
                  <td class="w-50 fw-600">{{ $t("订购日期") }}:</td>
                  <td>{{ order.userPayTime }}</td>
                </tr>
                <tr>
                  <td class="w-50 fw-600">{{ $t("订单状态") }}:</td>
                  <td>{{ $t("EnumGoodsOrderState_" + order.state) }}</td>
                </tr>
                <tr>
                  <td class="w-50 fw-600">{{ $t("总订单金额") }}:</td>
                  <td>{{ formatMoney(order.money) }}</td>
                </tr>
                <tr>
                  <td class="w-50 fw-600">{{ $t("邮寄方式") }}:</td>
                  <td>{{ $t("统一运费") }}</td>
                </tr>
                <tr>
                  <td class="w-50 fw-600">{{ $t("付款方式") }}:</td>
                  <td>{{ $t("现金") }}</td>
                </tr>

                <tr>
                  <td class="text-main text-bold">{{ $t("附加信息") }}</td>
                  <td class=""></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-9">
        <div class="card">
          <div class="card-header">
            <h5 class="h6 mb-0">{{ $t("订单详细信息") }}</h5>
          </div>
          <div class="card-body">
            <table
              v-if="isMobile"
              class="aiz-table table footable footable-1 breakpoint breakpoint-xs"
              style=""
            >
              <thead>
                <tr class="footable-header">
                  <th
                    class="footable-first-visible"
                    style="display: table-cell;"
                  >
                    #
                  </th>
                  <th style="display: table-cell;" width="30%">
                    {{ $t("产品") }}
                  </th>
                  <th data-breakpoints="md" style="display: none;">
                    {{ $t("店铺") }}
                  </th>
                  <th style="display: table-cell;">{{ $t("数量") }}</th>
                  <th data-breakpoints="md" style="display: none;">
                    {{ $t("交货类型") }}
                  </th>
                  <th
                    class="footable-last-visible"
                    style="display: table-cell;"
                  >
                    {{ $t("价格") }}
                  </th>
                  <th
                    class="text-right"
                    data-breakpoints="md"
                    style="display: none;"
                  >
                    {{ $t("进行评论") }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <template v-for="(item, index) in order.orderItems">
                  <tr :key="index * 2">
                    <td
                      class="footable-first-visible"
                      style="display: table-cell;"
                    >
                      <van-icon
                        :name="item.isExpanded ? 'minus' : 'plus'"
                        class="footable-toggle fooicon"
                        @click="onClickExpandButton(item)"
                      />
                      {{ index + 1 }}
                    </td>
                    <td style="display: table-cell;">
                      <a
                        href="javascript:void(0);"
                        @click="
                          jump(
                            `/product?goodsId=${item.goodsId}&shopId=${order.shopId}`
                          )
                        "
                      >
                        {{ item.goodsName }} - {{ item.goodsSpecName }}
                      </a>
                    </td>
                    <td style="display: none;">
                      <span>{{ item.shopUsername }}</span>
                    </td>
                    <td style="display: table-cell;">{{ item.number }}</td>
                    <td style="display: none;"></td>
                    <td
                      class="footable-last-visible"
                      style="display: table-cell;"
                    >
                      {{ formatMoney(item.money) }}
                    </td>
                    <td class="text-right" style="display: none;"></td>
                  </tr>
                  <tr
                    v-if="item.isExpanded"
                    :key="index * 2 + 1"
                    class="footable-detail-row"
                  >
                    <td colspan="4">
                      <table class="footable-details aiz-table table">
                        <tbody>
                          <tr>
                            <th>{{ $t("店铺") }}</th>
                            <td style="display: table-cell;">
                              {{ item.shopUsername }}
                            </td>
                          </tr>
                          <tr>
                            <th>{{ $t("交货类型") }}</th>
                            <td style="display: table-cell;"></td>
                          </tr>
                          <tr>
                            <th>{{ $t("进行评论") }}</th>
                            <td class="text-right" style="display: table-cell;">
                              <button
                                class="btn btn-primary btn-sm"
                                @click="productReview(item)"
                                :disabled="item.hasComment"
                              >
                                {{
                                  item.hasComment
                                    ? $t("已评论")
                                    : $t("进行评论")
                                }}
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
            <table
              v-else
              class="aiz-table table footable footable-1 breakpoint-xl"
              style=""
            >
              <thead>
                <tr class="footable-header">
                  <th
                    class="footable-first-visible"
                    style="display: table-cell;"
                  >
                    #
                  </th>
                  <th style="display: table-cell;" width="30%">
                    {{ $t("产品") }}
                  </th>
                  <th data-breakpoints="md" style="display: table-cell;">
                    {{ $t("店铺") }}
                  </th>
                  <th style="display: table-cell;">{{ $t("数量") }}</th>
                  <th data-breakpoints="md" style="display: table-cell;">
                    {{ $t("交货类型") }}
                  </th>
                  <th class="" style="display: table-cell;">
                    {{ $t("价格") }}
                  </th>
                  <th
                    class="text-right footable-last-visible"
                    data-breakpoints="md"
                    style="display: table-cell;"
                  >
                    {{ $t("进行评论") }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in order.orderItems"
                  :key="item.id"
                  data-expanded="true"
                >
                  <td
                    class="footable-first-visible"
                    style="display: table-cell;"
                  >
                    {{ index + 1 }}
                  </td>
                  <td style="display: table-cell;">
                    <a
                      href="javascript:void(0);"
                      @click="
                        jump(
                          `/product?goodsId=${item.goodsId}&shopId=${order.shopId}`
                        )
                      "
                    >
                      {{ item.goodsName }} - {{ item.goodsSpecName }}
                    </a>
                  </td>
                  <td style="display: table-cell;">
                    {{ item.shopUsername }}
                  </td>
                  <td style="display: table-cell;">
                    {{ item.number }}
                  </td>
                  <td style="display: table-cell;"></td>
                  <td class="" style="display: table-cell;">
                    {{ formatMoney(item.money) }}
                  </td>
                  <td
                    class="text-right footable-last-visible"
                    style="display: table-cell;"
                  >
                    <button
                      class="btn btn-primary btn-sm"
                      @click="productReview(item)"
                      :disabled="item.hasComment"
                    >
                      {{ item.hasComment ? $t("已评论") : $t("进行评论") }}
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="card">
          <div class="card-header">
            <b class="fs-15">{{ $t("订单金额") }}</b>
          </div>
          <div class="card-body pb-0">
            <table class="table-borderless table">
              <tbody>
                <tr>
                  <td class="w-50 fw-600">{{ $t("小计") }}</td>
                  <td class="text-right">
                    <span class="strong-600">{{
                      formatMoney(order.money)
                    }}</span>
                  </td>
                </tr>
                <tr>
                  <td class="w-50 fw-600">{{ $t("税") }}</td>
                  <td class="text-right">
                    <span class="text-italic">{{ formatMoney(0) }}</span>
                  </td>
                </tr>
                <tr>
                  <td class="w-50 fw-600">{{ $t("优惠券") }}</td>
                  <td class="text-right">
                    <span class="text-italic">{{ formatMoney(0) }}</span>
                  </td>
                </tr>
                <tr>
                  <td class="w-50 fw-600">{{ $t("全部的") }}</td>
                  <td class="text-right">
                    <strong>
                      <span>
                        {{ formatMoney(order.money) }}
                      </span>
                    </strong>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div v-if="`,${paramMapAll['SHOP_SELLER_ORDER_DETAIL_PROPS']},`.includes(',shippings,')" class="card">
          <div class="card-header">
            <b class="fs-15">{{ $t("物流详情") }}</b>
          </div>
          <div class="card-body pb-0">
            <table class="table-borderless table">
              <tbody>
              <template v-if="order.shippingState !== 'BEFORE_SHIPPING'">
                <tr v-for="shipping in order.shippings">
                  <div class="d-flex">
                    <div style="font-weight: bold;">{{ shipping.title }}</div>
                    <div class="ft-12 ml-2">{{ shipping.content }}</div>
                  </div>
                  <div class="text-grey">{{ shipping.time }}</div>
                </tr>
              </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <ProductCommentModal
      ref="productCommentModal"
      @commentSuccess="onCommentSuccess"
    />
  </AccountOpePanel>
</template>
<script>
import AccountOpePanel from "@/components/AccountOpePanel.vue";
import ProductCommentModal from "@/components/ProductCommentModal.vue";
import { DeviceUtil } from "@/utils/deviceUtil";
import { getGoodsOrderUpdate } from "@/api/goodsOrder";

export default {
  components: {
    AccountOpePanel,
    ProductCommentModal
  },
  data() {
    return { order: {} };
  },
  computed: {
  },
  methods: {
    productReview(item) {
      this.$refs.productCommentModal.show(item.id, item.goodsName);
    },
    onCommentSuccess(id) {
      const item = this.order.orderItems.find(item => item.id === id);
      if (item) {
        item.hasComment = true;
      }
    },
    onClickExpandButton(item) {
      item.isExpanded = !item.isExpanded
      // this.$set(item,'isExpanded',!item.isExpanded)
    }
  },
  async created() {
    const res = await getGoodsOrderUpdate(this.$route.query.id);
    res.data.orderItems.forEach(item => {
      item.hasComment = !!item.goodsEvaluationId;
      item.isExpanded = true;
    });
    this.order = res.data;
  }
};
</script>
<style scoped>

</style>
